import Ball from '@components/ball';
import { FormText } from '@components/form';
import { Flex } from '@phi/components/layout';
import { color_parser } from '@features/color-picker/color-parser';
import { Button, small_height } from '@phi/components';
import { defineComponent, h } from 'vue';
import { rem } from '@phi/util/css';
import { default_face_color } from '@phi/constants';
import { handle } from '@vaaas/fpts/result';

const DEFAULT = handle(() => '#000000')(color_parser(default_face_color));

export const CurrentColorRow = defineComponent({
    props: {
        value: {
            required: true,
            type: String,
        },
    },

    emits: {
        'update:value': (x: string) => true,
    },

    methods: {
        onClear() { this.$emit('update:value', DEFAULT); },
    },

    render() {
        return h(Flex, {
            gap: 'tight',
            align: 'center',
            direction: 'row',
        }, () => [
            h(Ball, { diameter: rem(small_height() ? 2.5 : 4), color: this.value }),

            h(FormText, {
                class: 'flexible',
                value: this.value,
                parser: color_parser,
                'onUpdate:value': x => this.$emit('update:value', x),
                select_all_on_focus: true,
            }),

            h(Button, { onClick: this.onClear }, () => 'Clear'),
        ]);
    },
});
